import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '../ui/dialog';
import { shotUrl } from './analysisData';

// Thumbnails of the captured screens; a click opens the screen full size, arrows (or ← →) step through.
export default function ShotGallery({ slug, brand, images }) {
  const [open, setOpen] = useState(null);
  const count = images.length;
  const step = d => setOpen(i => (i + d + count) % count);

  useEffect(() => {
    if (open == null) return undefined;
    const onKey = e => {
      if (e.key === 'ArrowLeft') step(-1);
      if (e.key === 'ArrowRight') step(1);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  // step only depends on count, which open changes cannot alter
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, count]);

  if (count === 0) return <p className="text-sm text-ink-dim">No screenshots stored for this game.</p>;
  const current = open != null ? images[open] : null;

  return (
    <>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
        {images.map((img, i) => (
          <button
            key={img.file}
            type="button"
            onClick={() => setOpen(i)}
            className="group text-left rounded-lg border border-white/10 bg-surface-2 overflow-hidden focus:outline-none focus:ring-2 focus:ring-cta"
          >
            <img
              src={shotUrl(slug, img.file, brand)}
              alt={img.label}
              loading="lazy"
              className="aspect-video w-full object-cover object-top transition-opacity group-hover:opacity-80"
            />
            <p className="px-2 py-1.5 text-[11px] font-medium text-ink-dim truncate">{img.label}</p>
          </button>
        ))}
      </div>

      <Dialog open={current != null} onOpenChange={o => { if (!o) setOpen(null); }}>
        <DialogContent className="max-w-[min(1400px,95vw)]">
          {current && (
            <>
              <DialogTitle>{current.label}</DialogTitle>
              {current.note && <DialogDescription>{current.note}</DialogDescription>}
              <img src={shotUrl(slug, current.file, brand)} alt={current.label} className="max-h-[75vh] w-full object-contain" />
              <div className="flex items-center justify-between">
                <Button variant="ghost" size="sm" onClick={() => step(-1)}><ChevronLeft className="h-4 w-4" /> Previous</Button>
                <span className="text-[11px] text-ink-dim">{open + 1} / {count}</span>
                <Button variant="ghost" size="sm" onClick={() => step(1)}>Next <ChevronRight className="h-4 w-4" /></Button>
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
